import Wrapper from "../../../layout/Wrapper";
import VehicleContractServiceComponent from "../../../screens/contractControll/vehicleContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Service",
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleContractServiceComponent />
		</Wrapper>
	);
}